import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule }   from '@angular/router';
import { LoginComponent } from './login/login.component';
import { LoginLayoutComponent } from './login-layout/login-layout.component';
import { HomeLayoutComponent } from './home-layout/home-layout.component';
import { HomeComponent } from './home/home.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { CustomerComponent } from './customer/customer.component';
import { CustomerDetailsComponent } from './customer-details/customer-details.component';
import { MassSearchCustomersComponent } from './mass-search-customers/mass-search-customers.component';
import { TelcoComponent } from './telco/telco.component';
import { SubmitTelcoComponent } from './submit-telco/submit-telco.component';
import { MassSubmitTelcoComponent } from './mass-submit-telco/mass-submit-telco.component';
import { TelcoAuditTrailComponent } from './telco-audit-trail/telco-audit-trail.component';
import { ManageUsersComponent } from './manage-users/manage-users.component';
import { TemplateUploadComponent } from './mass-search-customers/template-upload/template-upload.component';
import { ChangePasswordComponent } from './manage-users/change-password/change-password.component';
import { ChangePasswordOthersComponent } from './manage-users/change-password-others/change-password-others.component';
import { ViewUserComponent } from './manage-users/view-user/view-user.component';
import { BatchUploadComponent } from './mass-submit-telco/batch-upload/batch-upload.component';
import { BatchUploadHistoryComponent } from './mass-submit-telco/batch-upload-history/batch-upload-history.component';
import { BatchUploadStatusComponent } from './mass-search-customers/batch-upload-status/batch-upload-status.component';
import { CompanyComponent } from './company/company.component';
import { BranchComponent } from './branch/branch.component';

const appRoutes: Routes = [
  // { path: '', pathMatch: 'full', component: LoginComponent },
  {
    path: '',
    component: LoginLayoutComponent, 
    children: [
      {
        path: '',
        component: LoginComponent , 
        pathMatch: 'full' 
      }
    ]
  },
  {
    path: '',                      
    component: HomeLayoutComponent,
    children: [
      { path: 'not-found', component: NotFoundComponent },
      { path: 'customer', component: CustomerComponent },
      { path: 'customer-details', component: CustomerDetailsComponent },
      { path: 'mass-search-customers', component: MassSearchCustomersComponent },
      { path: 'template-upload', component: TemplateUploadComponent },
      { path: 'telco', component: TelcoComponent },
      { path: 'home', component: HomeComponent },
      { path: 'submit-telco', component: SubmitTelcoComponent },
      { path: 'mass-submit-telco', component: MassSubmitTelcoComponent },
      { path: 'telco-audit-trail', component: TelcoAuditTrailComponent },
      { path: 'manage-users', component: ManageUsersComponent},
      { path: 'change-password', component: ChangePasswordComponent },
      { path: 'change-password-others', component: ChangePasswordOthersComponent },
      { path: 'view-user/:name', component: ViewUserComponent },
      { path: 'batch-upload', component: BatchUploadComponent },
      { path: 'batch-upload-history', component: BatchUploadHistoryComponent },
      { path: 'batch-upload-status', component: BatchUploadStatusComponent },
      { path: 'manage-company', component: CompanyComponent},
      { path: 'manage-branch', component: BranchComponent},
    ]
  },
  { path: '**', redirectTo: 'not-found' }
];

export const routing: ModuleWithProviders = RouterModule.forRoot(appRoutes);



// WEBPACK FOOTER //
// ./src/app/app.routing.ts